import BannerMarketing from './BannerMarketing';

export default BannerMarketing;
